import { ONBOARDING_GUIDE_STEPS } from '../../../../../services/exports/Constants';

export default {
  title: 'Snel starten',
  description: 'Doorloop deze gids om zo snel mogelijk live te gaan',
  steps: {
    [ONBOARDING_GUIDE_STEPS.Notifications]: 'Meldingsvoorkeur',
    [ONBOARDING_GUIDE_STEPS.OpenTimesAndLocation]: 'Openingstijden & locatie',
    [ONBOARDING_GUIDE_STEPS.Identity]: 'Restaurantidentiteit',
    [ONBOARDING_GUIDE_STEPS.OrderSettings]: 'Bestelinstellingen',
    [ONBOARDING_GUIDE_STEPS.Menu]: 'Menu instellen',
    [ONBOARDING_GUIDE_STEPS.Marketing]: 'Marketing & loyaliteit',
    [ONBOARDING_GUIDE_STEPS.MyStore]: 'Mijn winkel',
    [ONBOARDING_GUIDE_STEPS.GoLive]: 'Live gaan',
    [ONBOARDING_GUIDE_STEPS.Complete]: 'Voltooid',
  },
  toasts: {
    failed_to_load_onboarding: 'Onboardingstappen laden mislukt',
  },
};
